<av-content-container>
  <div class="col-6 mb-4 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.services.title'" icon="build"
      [columns]="serviceColumns" [rows]="serviceRows()"
      [countLabelKey]="'app.device.settings.count.services_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.services'" [pageSize]="5" />
  </div>

  <div class="col-6 mb-4 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.scheduled_tasks.title'" icon="schedule"
      [columns]="scheduledTaskColumns" [rows]="scheduledTaskRows()"
      [countLabelKey]="'app.device.settings.count.scheduled_tasks_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.scheduled_tasks'" [pageSize]="5" />
  </div>

  <div class="col-6 mb-4 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.startup_programs.title'" icon="power_settings_new"
      [columns]="startupProgramColumns" [rows]="startupProgramRows()"
      [countLabelKey]="'app.device.settings.count.startup_programs_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.startup_programs'" [pageSize]="5" />
  </div>

  <div class="col-6 mb-4 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.shortcut_programs.title'" icon="apps"
      [columns]="shortcutProgramColumns" [rows]="shortcutProgramRows()"
      [countLabelKey]="'app.device.settings.count.shortcut_programs_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.shortcut_programs'" [pageSize]="5" />
  </div>

  <div class="col-6 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.environment_variables.title'" icon="tune"
      [columns]="environmentVariableColumns" [rows]="environmentVariableRows()"
      [countLabelKey]="'app.device.settings.count.environment_variables_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.environment_variables'" [pageSize]="5" />
  </div>

  <div class="col-6 d-flex">
    <av-table-card [titleKey]="'app.device.settings.sections.resultant_set_of_policy.title'" icon="policy"
      [columns]="resultantPolicyColumns" [rows]="resultantPolicyRows()"
      [countLabelKey]="'app.device.settings.count.resultant_set_of_policy_found_suffix'"
      [emptyTextKey]="'app.device.settings.empty.resultant_set_of_policy'" [pageSize]="5" />
  </div>
</av-content-container>